import { clsx } from 'clsx';
import { NsKey } from 'enums/NsKey';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActorType } from '../../enums/actorType';

interface ActorTypeSelectorProps {
  value: ActorType;
  onChange: (actorType: ActorType) => void;
  typeMapping?: {
    natural: ActorType;
    legal: ActorType;
  };
}

const ActorTypeSelector: React.FC<ActorTypeSelectorProps> = ({
  value,
  onChange,
  typeMapping = {
    natural: ActorType.Natural,
    legal: ActorType.Legal
  }
}) => {
  const { t } = useTranslation(NsKey.ActorForm);
  const [active, setActive] = useState<ActorType>(value);

  useEffect(() => {
    setActive(value);
  }, [value]);

  const handleSelect = (actorType: ActorType) => {
    setActive(actorType);
    onChange(actorType);
  };

  return (
    <div className="font-lato flex items-center bg-section rounded-full cursor-pointer group">
      <div
        className={clsx(
          "w-1/2 font-bold text-center py-2 px-6 rounded-full transition-all duration-300 text-gray-700",
          active === typeMapping.natural
            ? "text-white bg-primary"
            : "hover:text-white hover:bg-primary group-hover:text-gray-700 group-hover:bg-transparent"
        )}
        onClick={() => handleSelect(typeMapping.natural)}
      >
        {t('ACTOR_FORM.LABELS.NATURAL_PERSON')}
      </div>
      <div
        className={clsx(
          "w-1/2 font-bold text-center py-2 px-6 rounded-full transition-all duration-300 text-gray-700",
          active === typeMapping.legal
            ? "text-white bg-primary"
            : "hover:text-white hover:bg-primary group-hover:text-gray-700 group-hover:bg-transparent"
        )}
        onClick={() => handleSelect(typeMapping.legal)}
      >
        {t('ACTOR_FORM.LABELS.LEGAL_ENTITY')}
      </div>
    </div>
  );
};

export default ActorTypeSelector;
